import { createContext } from 'react';

export const PublicTokenContext = createContext();